import { css, SerializedStyles } from '@emotion/react';

export const useStyles = () => ({
  whiteContentTopRadius: css({
    backgroundColor: "#ffffff",
    marginTop: "-10px !important",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
    overflow: "hidden",
  }),
  listItemsDiv: css({
    overflow: "auto",
  }),
  confirmAllButton: css({
    borderBottom: "1px solid #d2d4d6",
    textAlign: "center",
    fontSize: 14,
    color: "#2d9dd5",
    fontWeight: "bold",
    padding: "8px 0",
  }),
  listItemsContainer: css({
    backgroundColor: "#f3f6f6",
  }),
  listItemsButton: css({
    backgroundColor: "white",
    borderBottom: "1px solid #d2d4d6",
    marginBottom: "3px",
    padding: "2px 15px 5px 15px",
    textTransform: "capitalize",
    borderRadius: 0,
    width: "100%",
  }),
  listItemsButtonQuantity: css({
    fontSize: 12,
    textAlign: "end",
  }),
  listItemsButtonBox: css({
    backgroundColor: "red",
    fontSize: 10,
    marginBottom: 1,
    color: "#FFFFFF",
    padding: "1px 0",
  }),
  listItemsButtonBoxTitle: css({
    fontSize: 9,
    textAlign: "left",
    color: "#abadb1",
    lineHeight: 1.5,
  }),
});
